import React from "react";
import { EonUiTagPill } from "@eon-ui/eon-ui-components-react";
import { useTriggerSearch } from "@me8eon/search";
import { useGuiFilters } from "@me8eon/filters";
import { intentSearchName, useDoAi } from "@me8eon/react_intent";
import { useTranslation } from "@me8eon/translation";
import { useFeatureFlag } from "@me8eon/featureflags";

type Props = {
    isFeedbackSend: boolean;
};

export const FeedbackSupportActions = (props: Props) => {
    const { isFeedbackSend } = props;
    const t = useTranslation();
    const trigger = useTriggerSearch();
    const [filters] = useGuiFilters();
    const handleAiQueryIntent = useDoAi();

    return (
        <div className="issue-resolver-wrapper">
            <div style={{ color: isFeedbackSend ? "#212121" : "000000" }}>
                {isFeedbackSend
                    ? t("chatBot.resolveIssueAfterFeedback")
                    : t("chatBot.resolveIssue")}
            </div>
            <div className="issue-resolver-content">
                <EonUiTagPill
                    key={"incident"}
                    text={t("chatBot.quickActions.actions.createIncident")}
                    title={t("chatBot.quickActions.tooltips.createIncident")}
                    class="feedback-tag"
                    scheme="neutral800"
                    isDisabled={!isFeedbackSend}
                    onClick={() => {
                        if (!isFeedbackSend) return;
                        handleAiQueryIntent(t("chatBot.quickActions.actions.createIncident"));
                    }}
                ></EonUiTagPill>
                <EonUiTagPill
                    key={"liveAgent"}
                    text={t("chatBot.quickActions.actions.chatWithServiceDesk")}
                    title={t(
                        "chatBot.quickActions.tooltips.chatWithServiceDesk"
                    )}
                    class="feedback-tag"
                    scheme="neutral800"
                    isDisabled={!isFeedbackSend}
                    onClick={() => {
                        if (!isFeedbackSend) return;
                        handleAiQueryIntent(t("chatBot.quickActions.actions.chatWithServiceDesk"));
                    }}
                ></EonUiTagPill>
                <EonUiTagPill
                    key={"requestCallback"}
                    text={t("chatBot.quickActions.actions.requestCallback")}
                    title={t(
                        "chatBot.quickActions.tooltips.requestCallback"
                    )}
                    class="feedback-tag"
                    scheme="neutral800"
                    isDisabled={!isFeedbackSend}
                    onClick={() => {
                        if (!isFeedbackSend) return;
                        handleAiQueryIntent(t("chatBot.quickActions.actions.requestCallback"));
                    }}
                ></EonUiTagPill>
            </div>
        </div>
    );
};
